import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColorUtil {

  constructor(
  
  ) { }

  calculatePoint(i: number, intervalSize: number, colorRangeInfo: any) {
    var { colorStart, colorEnd, useEndAsStart } = colorRangeInfo;
    return (useEndAsStart
      ? (colorEnd - (i * intervalSize))
      : (colorStart + (i * intervalSize)));
  }

  interpolateColors(dataLength: number, colorScale: any, colorRangeInfo: any) {
    var { colorStart, colorEnd } = colorRangeInfo;
    var colorRange = colorEnd - colorStart;
    var intervalSize = colorRange / dataLength;
    var i: number, colorPoint: any;
    var colorArray = [];
  
    for (i = 0; i < dataLength; i++) {
      colorPoint = this.calculatePoint(i, intervalSize, colorRangeInfo);
      colorArray.push(colorScale(colorPoint));
    }
  
    return colorArray;
  }  
  
}
